import type * as Models from "@/redux/models"

/**
 * Kill switch for server-rendered heatmap rasters.
 *
 * When true (and the response carries `rasterUrl` + `bounds`), heatmap
 * layers render a single image overlay per field/pivot instead of one
 * polygon per cell/sector. Flip to false to force the legacy polygon path
 * everywhere. Once rasters are verified on a large farm (see
 * docs/irrigation-heatmap-raster-rendering.md §2.4) the polygon path,
 * `mergeHeatmapCells` and `heatmap-colors.ts` can be deleted along with
 * this flag.
 */
export const HEATMAP_RASTER_ENABLED = true

export function getHeatmapRaster(
  grid:
    | Pick<Models.IrrigationHeatmapGrid, "bounds" | "rasterUrl">
    | null
    | undefined,
): { bounds: Models.HeatmapBounds; rasterUrl: string } | null {
  if (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- kill switch; flips to false for rollback
    HEATMAP_RASTER_ENABLED &&
    grid &&
    typeof grid.rasterUrl === "string" &&
    grid.rasterUrl.length > 0 &&
    grid.bounds
  ) {
    return { bounds: grid.bounds, rasterUrl: grid.rasterUrl }
  }
  return null
}
